<template>
	<div>
		<div class="main-filter">
			<el-form inline :model="formInline" class="demo-form-inline">
				<el-form-item label="设备名称：">
					<el-autocomplete
						v-model.trim="formInline.smartDeviceName"
						:fetch-suggestions="querySearchAsync"
						clearable
						placeholder="请输入内容"
					></el-autocomplete>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onSearch" icon="el-icon-search">搜索</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="main-content">
			<div class="main-content-title">
				<p>共有 {{ total }} 条结果</p>
				<el-button type="primary" @click="modifyParkInfo($event, false)" icon="el-icon-plus">新增</el-button>
			</div>
			<Table
				:loading="loading"
				:table-data="tableData"
				:total="total"
				:table-head="tableHead"
				:current-page.sync="queryData.current"
				:page-size.sync="queryData.size"
				:operation-column-width="240"
				:is-show-selection="false"
				:showOperation="true"
				@change-page="getList"
				:tableHeight="tableHeight"
			>
				<!-- 插槽操作栏固定属性operation -->
				<template #enabled="{ scope }">
					<el-switch inactive-text="否" active-text="是" v-model="scope.row.enabled" @change="changeOpen(scope.row)"> </el-switch>
				</template>
				<template #useParameter="{ scope }">
					<el-button @click="showUseParameter(scope.row)" size="mini" type="text">
						查看({{ (scope.row.smartDevicePricingDto && scope.row.smartDevicePricingDto.length) || 0 }})
					</el-button>
				</template>
				<template #operation="{ scope }">
					<el-button @click="modifyParkInfo($event, true, scope.row)" size="mini" type="primary"> 查看 </el-button>
					<el-button
						@click="modifyParkInfo($event, false, scope.row)"
						size="mini"
						:type="scope.row.enabled ? 'info' : 'warning'"
						:disabled="scope.row.enabled"
					>
						修改
					</el-button>
					<el-button @click="createQrcode(scope.row)" size="mini" type="success"> 生成二维码 </el-button>
				</template>
			</Table>
		</div>
		<createView ref="createView" :isShowDetail="isShowDetail" @getList="getList"></createView>
		<ShowCode ref="showCode"></ShowCode>
		<ShowParams ref="showParams"></ShowParams>
	</div>
</template>

<script>
export default {
	name: 'configManager',
	components: {
		Table: () => import('@/components/Table/table'),
		createView: () => import('./newDialog.vue'),
		ShowCode: () => import('./showCode.vue'),
		ShowParams: () => import('./showParams.vue'),
	},
	data() {
		return {
			formInline: {
				smartDeviceName: '',
			},
			tableHead: [
				{
					label: '设备编号',
					prop: 'serialNumber',
					formatter: (row) => {
						return row.serialNumber || '-';
					},
				},
				{
					label: '设备名称',
					prop: 'smartDeviceName',
					formatter: (row) => {
						return row.smartDeviceName || '-';
					},
				},

				{
					label: '应用参数',
					prop: 'useParameter',
				},

				{
					label: '地区',
					prop: 'regions',
					formatter: (row) => {
						return row.regions && row.regions.length > 0 ? row.regions.map((item) => item.title).join('-') : '-';
					},
				},
				{
					label: '分配机构',
					prop: 'medicalOrganizationName',
					formatter: (row) => {
						return row.medicalOrganizationName || '-';
					},
				},
				{
					label: '是否启用',
					prop: 'enabled',
					width: 110,
				},
			],
			loading: false,
			queryData: {
				current: 1,
				size: 10,
			},
			total: 0,
			tableData: [],
			options: [],
			isShowDetail: false,
			link: '',
			searchMedical: '',
		};
	},
	computed: {
		tableHeight() {
			return window.innerHeight - 300;
		},
	},
	mounted() {
		this.getList();
	},
	methods: {
		// 查询条件
		onSearch() {
			this.queryData.current = 1;
			this.getList(null);
		},
		changeOpen(row) {
			this.$http
				.put(row._links.update.href, row)
				.then((res) => {
					if (res.data && res.data.success) {
						this.$message.success('操作成功');
						this.getList();
					}
				})
				.catch((e) => {});
		},
		// 搜索建议
		querySearchAsync(queryString, cb) {
			queryString ? this.getList('filter') : '';
			clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
				cb(this.options);
			}, 1000 * Math.random());
		},
		//获取列表
		getList(type = '') {
			type == 'filter' ? '' : (this.loading = true);
			let data = {
				...this.formInline,
				...this.queryData,
			};
			this.$http
				.get(this.api['SmartDeviceConfigures#index'].href, { params: data })
				.then((res) => {
					if (res.data && res.data.success) {
						if (type == 'filter') {
							this.options = res.data.collection.map((item) => {
								return {
									...item,
									value: item.smartDeviceName,
								};
							});
						} else {
							this.tableData = res.data.collection || [];
							this.total = res.data.pagination.totalItems || 0;
							this.link = res.data._links.create.href || '';
							this.searchMedical = res.data._links.SearchAreaMedicalOrganizations.href || '';
							this.loading = false;
						}
					}
				})
				.catch((e) => {
					this.loading = false;
				});
		},
		modifyParkInfo(event, isShowDetail, row) {
			let data = {
				row: row || null,
				link: row ? row._links.update.href : this.link,
				searchMedical: this.searchMedical,
			};
			this.$refs.createView.init(data);
			this.isShowDetail = isShowDetail;
		},
		// 生成二维码
		createQrcode(row) {
			this.$refs.showCode.name = '设备使用二维码';
			this.$refs.showCode.qrCodeUrl = row.qrCodeUrl;
			this.$refs.showCode.centerDialogVisible = true;
		},
		// 查看使用参数
		showUseParameter(row) {
			if (!row.smartDevicePricingDto || row.smartDevicePricingDto.length == 0) return;
			this.$refs.showParams.showVisible = true;
			this.$refs.showParams.tableData = row.smartDevicePricingDto || [];
		},
	},
	created() {},
};
</script>

<style lang="scss" scoped>
.demo-form-inline {
	/deep/ .el-select {
		width: 120px !important;
		.el-input {
			width: 120px !important;
			.el-input__inner {
				width: 120px !important;
			}
		}
	}
	/deep/ .el-input {
		width: 160px;
	}
}
.main-content {
	&-title {
		line-height: 48px;
		display: flex;
		justify-content: space-between;
		.el-button {
			line-height: 32px;
			padding: 0 16px;
			height: 32px;
			margin-top: 8px;
		}
	}
}
</style>